import { render, staticRenderFns } from "./RoleForm.vue?vue&type=template&id=e6eb086c&"
import script from "./RoleForm.vue?vue&type=script&lang=ts&"
export * from "./RoleForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports